export default "__VITE_ASSET__C7ar$ktO__"